import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedDetail, type PdpSharedDetailProps } from './PdpSharedDetail.tsx';
import { PdpSharedDetailItemInvoice } from './PdpSharedDetailItemInvoice.tsx';

import { type PdpSharedDetailReference_item$key } from './__generated__/PdpSharedDetailReference_item.graphql.ts';
import { type PdpSharedDetailReference_user$key } from './__generated__/PdpSharedDetailReference_user.graphql.ts';

type Props = PdpSharedDetailProps & {
    item: PdpSharedDetailReference_item$key;
    user: PdpSharedDetailReference_user$key | null | undefined;
    hideInvoice?: boolean;
};

export const PdpSharedDetailReference: FC<Props> = ({
    item: itemRef,
    user: userRef,
    hideInvoice,
    ...props
}) => {
    const item = useFragment(
        graphql`
            fragment PdpSharedDetailReference_item on Item {
                isAvailable
                isSold
                hasPrivateListing
                isListingUnlisted
                hasActiveHoldForBuyer(buyerId: $userId) @include(if: $fetchUser)
                seller {
                    isAccessible
                }
                ...PdpSharedDetailItemInvoice_item
            }
        `,
        itemRef
    );
    const user = useFragment(
        graphql`
            fragment PdpSharedDetailReference_user on User {
                ...PdpSharedDetailItemInvoice_user
            }
        `,
        userRef
    );
    const {
        isAvailable,
        isSold,
        hasPrivateListing,
        hasActiveHoldForBuyer,
        isListingUnlisted,
        seller,
    } = item || {};
    const showInvoice =
        (isAvailable || hasActiveHoldForBuyer) &&
        !isSold &&
        !hasPrivateListing &&
        !hideInvoice &&
        !isListingUnlisted &&
        seller?.isAccessible;

    return (
        <>
            <PdpSharedDetail {...props} limitLength />
            {showInvoice && (
                <PdpSharedDetailItemInvoice item={item} skuId={props.selectedSkuId} user={user} />
            )}
        </>
    );
};
